import { createStore, GetState, SetState } from '@oneappexchange/lwc-wired';
import { State } from 'zustand';
import { IS_DEVELOPMENT } from '~/modules/config';

// Click-time analytics context for AI-Overview related-search (NBQ) pill
// clicks. Populated at click time before navigation and consumed by the
// related-search GA4 handler when the resulting search-done event fires.
// Lives out-of-band from the URL and searchStore so pill-view transients
// do not bleed into the router/query model.
export interface AiSearchAnalyticsPending {
    position?: number;
    aiSummaryCount?: number;
}

export interface AiSearchAnalyticsState extends State {
    pending?: AiSearchAnalyticsPending;
}

const initialState: AiSearchAnalyticsState = {
    pending: undefined,
};

export const selectPendingAiSearchAnalytics = (state: AiSearchAnalyticsState): AiSearchAnalyticsPending | undefined =>
    state.pending;

export const aiSearchAnalyticsStore = createStore(
    initialState,

    (set: SetState<AiSearchAnalyticsState>, get: GetState<AiSearchAnalyticsState>) => ({
        setPending(context: AiSearchAnalyticsPending) {
            set(function setPending(draft: AiSearchAnalyticsState) {
                draft.pending = context;
            });
        },

        // Returns the pending context and clears it so a manual refresh /
        // duplicate search-done event does not re-fire with stale values.
        consumePending(): AiSearchAnalyticsPending | undefined {
            const current = get().pending;
            set(function clearPending(draft: AiSearchAnalyticsState) {
                draft.pending = undefined;
            });
            return current;
        },

        reset() {
            set(function resetStore() {
                return { ...initialState };
            });
        },
    }),
    'aiSearchAnalyticsStore',
    IS_DEVELOPMENT,
);
